export const DOCKED_CHAT_CHANGED_EVENT = 'wenext:docked-chat-changed'

export type DockedChatChangedDetail = { open: boolean }

const BODY_ATTR = 'data-docked-chat-open'

export function isDockedChatOpen(): boolean {
  if (typeof document === 'undefined') return false
  return document.body.hasAttribute(BODY_ATTR)
}

export function setDockedChatOpen(open: boolean): void {
  if (typeof document === 'undefined') return
  if (open) document.body.setAttribute(BODY_ATTR, 'true')
  else document.body.removeAttribute(BODY_ATTR)
  window.dispatchEvent(
    new CustomEvent<DockedChatChangedDetail>(DOCKED_CHAT_CHANGED_EVENT, { detail: { open } }),
  )
}
